export default __webpack_public_path__ + "static/media/export_icon.b6e2ba78.svg";